import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'
import * as atualizacaoItensOrcamentoLegadoActions from 'app/redux/atualizacaoItensOrcamentoLegadoSlice'

declare var window:any


export type DefinirValorDescontoMercadoriasNacionaisInput = {
    valorDesconto: number
}

export async function definirValorDescontoMercadoriasNacionais(input: DefinirValorDescontoMercadoriasNacionaisInput) {
    const orcamentoAtualizado = await microuniversoApi.Orcamento.DefinirValorDescontoSobreMercadoriasNacionais(
        store.getState().orcamento.IdentificadorOrcamento,
        input.valorDesconto
    )

    const atualizarEstado = () => {
        const orcamentoLegado = window.orcamentoController.model

        orcamentoLegado.atualizar(orcamentoAtualizado, true, true)

        store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(orcamentoAtualizado))

        const atualizarEstadoItensLegado = () => {
            //const itensLegado = orcamentoLegado.get('ItensOrcamento')

            for(let itemAtualizado of (orcamentoAtualizado.ItensOrcamento ?? [])) {
                //const itemLegado = itensLegado.models.find(i => i.get('Identificador') == itemAtualizado.Identificador)
                //itemLegado.atualizar(itemAtualizado,true,true,true)

                store.dispatch(atualizacaoItensOrcamentoLegadoActions.atualizarItem({
                    identificador: itemAtualizado.Identificador,
                    dadosItem: itemAtualizado
                }))
            }
        }

        atualizarEstadoItensLegado()
    }

    atualizarEstado()
}